export default function cleanValidateStringPropValue(
  propValue,
  defaultValue,
  supportedValues,
  messageIfMissing,
  messageIfNotSupported,
  logger
) {
  if (!propValue) {
    if (!!logger) {
      logger(messageIfMissing);
    }
  }
  const cleanedPropValue = !!propValue?`${propValue}`.trim().toLowerCase():defaultValue;
  if (!supportedValues.includes(cleanedPropValue)) {
    if (!!logger) {
      logger(messageIfNotSupported);
    }
    return defaultValue;
  }
  return cleanedPropValue;
}

export function getValidProp(propValue, propName, defaultPropValue, supportedPropValues, componentName, debugLogger) {
  return cleanValidateStringPropValue(
    propValue,
    defaultPropValue,
    supportedPropValues,
    `${componentName}: missing ${propName}. Used "${defaultPropValue}" as default instead.`,
    `${componentName}: invalid "${propValue}" ${propName} detected. Used "${defaultPropValue}" as default instead.`,
    debugLogger
  );
}

